import * as s from "./schema";
import {bannerFromLegacyScene} from "./legacy";
import {type GridDocument} from "./document";

// Explicit import of the local step-0 experiment; never re-runs designer defaults.
const proofBannerSchema = s.shape({
  instanceId: s.text, templateKey: s.text, product: s.text, contentType: s.text, set: s.nullable(s.text),
  content: s.shape({title: s.text, subtitle: s.text, date: s.text, badge: s.text, productName: s.text}),
  appearance: s.shape({layout: s.range(1, Infinity, true), base: s.text,
    backgroundUrl: s.assetUrl, backgroundX: s.finite, backgroundY: s.finite, backgroundScale: s.range(Number.MIN_VALUE),
    backgroundRotate: s.finite, backgroundFlip: s.shape({x: s.boolean, y: s.boolean}), logoUrl: s.assetUrl, font: s.text}),
});
const proofSchema = s.shape({schemaVersion: s.literal(1), kind: s.literal("grid-proof"), banners: s.array(proofBannerSchema)});
export function migrateGridDocument(value: unknown): unknown {
  const envelope = s.object(value, "grid");
  if (envelope.schemaVersion !== 1 && envelope.schemaVersion !== 2) s.fail("grid.schemaVersion", "Unsupported document version");
  if (envelope.kind === "custom-grid") return value;
  if (envelope.schemaVersion !== 1) s.fail("grid.kind", "Grid proofs require version 1");
  if (envelope.kind !== "grid-proof") s.fail("grid.kind", "Unsupported document kind");
  const old = proofSchema(value, "proof");
  const document: GridDocument = {schemaVersion: 1, kind: "custom-grid", title: "Imported Grid proof", banners: old.banners.map((banner) => {
    if (!["social/Twitter", "releases/Twitter", "email/Email02"].includes(banner.templateKey)) s.fail("proof.templateKey", "Unsupported proof template");
    const id = banner.templateKey.split("/")[1];
    const a = banner.appearance;
    return bannerFromLegacyScene({...banner, layout: a.layout}, {
      titles: {main: banner.content.title}, subtitles: {main: banner.content.subtitle}, dates: {main: banner.content.date},
      badges: {main: banner.content.badge}, productNames: {main: banner.content.productName},
      layoutOption: a.layout, base: a.base, bgOption: "custom", fontOption: a.font,
      customBg: a.backgroundUrl, logoVariants: {[id]: a.logoUrl},
      bgX: {[id]: a.backgroundX}, bgY: {[id]: a.backgroundY}, bgScale: {[id]: a.backgroundScale},
      bgRotate: {[id]: a.backgroundRotate}, bgFlip: {[id]: a.backgroundFlip},
    });
  })};
  return document;
}
